import { AuthStateService } from "./auth-state.service";

export const authStateService = new AuthStateService();
